import { create } from "zustand";
import { FundFacetItem } from "../components/GemelData/MiniGemelDataFacetsList";



// ממשק ה-Store
export interface SelectedFundFacetStore {
  selectedItem: FundFacetItem | null; // הפריט הנבחר
  setSelectedItem: (item: FundFacetItem | null) => void; // פונקציה לעדכון הפריט
}

// יצירת ה-Store
export const useSelectedFundFacetStore = create<SelectedFundFacetStore>((set: (partial: Partial<SelectedFundFacetStore>) => void) => ({
  selectedItem: null as FundFacetItem | null, // ברירת מחדל: אין פריט נבחר
  setSelectedItem: (item: FundFacetItem) => set({ selectedItem: item }), // עדכון הפריט הנבחר
}));

interface FacetFiltersState {
  activeFacetFilters: FundFacetItem[];
  replaceFilters: (items: FundFacetItem[]) => void;
  addFilter: (item: FundFacetItem) => void;
  removeFilter: (facetType: FundFacetItem["facetType"], value: any) => void;
  clearFilters: () => void;
}

export const useFacetFiltersStore = create<FacetFiltersState>((set, get) => ({
  activeFacetFilters: [],
  replaceFilters: (items) => set({ activeFacetFilters: items }),
  addFilter: (item) => {
    const exists = get().activeFacetFilters.some(
      (i) => i.facetType === item.facetType && i.facetValue === item.facetValue
    );
    if (!exists) set({ activeFacetFilters: [...get().activeFacetFilters, item] });
  },
  removeFilter: (facetType, value) =>
    set({
      activeFacetFilters: get().activeFacetFilters.filter(
        (i) => !(i.facetType === facetType && i.facetValue === value)
      ),
    }),
  clearFilters: () => set({ activeFacetFilters: [] }),
}));
